import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { FestivalStatus } from "@/types/tina-festival-page";

/** Drawn as `ItemStatusBadge` draws an item's status: a tinted badge, keyed by the status. */
const STYLES: Record<FestivalStatus, string> = {
  waiting_approval: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  waiting_venue: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  group_waiting: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  live_changes: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  publishing: "bg-blue-500/15 text-blue-700 dark:text-blue-300",
  live: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
  failed: "bg-red-500/15 text-red-700 dark:text-red-300",
  rejected: "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300",
  ended_unapproved: "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300",
};

interface FestivalStatusBadgeProps {
  /** The wire status; one this build does not know still shows, in the muted style. */
  status: string;
  /** Tina's `status_label`, shown as it comes. */
  label: string;
}

export function FestivalStatusBadge({
  status,
  label,
}: FestivalStatusBadgeProps) {
  const style = Object.hasOwn(STYLES, status)
    ? STYLES[status as FestivalStatus]
    : "bg-muted text-foreground";
  return <Badge className={cn(style)}>{label}</Badge>;
}
